import { AppService } from '@/bundles/App/models/AppService';
import { Nullable } from '@/utils/types';
import { mapDealsFilterOptions } from '@/bundles/Deals/mappers/mapDealsFilterOptions';
import {
  IDealsDashboardFiltersDto,
  IGetDealsDashboardListDto,
} from '@/bundles/Deals/dto';
import {
  IDealsBreakdownsGetOne,
  IDealsDashboardFilterOptions,
  IDealsDashboardFilterOptionsGetOne,
  IDealsDashboardKpisGetOne,
  IDealsDetailGetOne,
  IDealsListGetOne,
  IDealsYearSummaryGetOne,
} from '@/bundles/Deals/types';
import DealsYearAggregateModel from '@/bundles/Deals/models/DealsYearAggregateModel';

export default class DealServiceNest extends AppService {
  async getFilterOptions (
    controller: Nullable<AbortController> = null,
  ): Promise<IDealsDashboardFilterOptions> {
    try {
      const response: IDealsDashboardFilterOptionsGetOne = await this.transport.get('/dashboard/deals/filter-options', {}, controller);
      return mapDealsFilterOptions(response);
    } catch (error) {
      throw this.errorMapper.mapToCodeModel(error);
    }
  }

  async getKpis (
    params: IDealsDashboardFiltersDto,
    controller: Nullable<AbortController> = null,
  ): Promise<IDealsDashboardKpisGetOne> {
    try {
      return await this.transport.get('/dashboard/deals/kpis', params, controller);
    } catch (error) {
      throw this.errorMapper.mapToCodeModel(error);
    }
  }

  async getYearSummary (
    params: IDealsDashboardFiltersDto,
    controller: Nullable<AbortController> = null,
  ): Promise<DealsYearAggregateModel[]> {
    try {
      const response: IDealsYearSummaryGetOne = await this.transport.get('/dashboard/deals/year-summary', params, controller);
      return response.map(a => new DealsYearAggregateModel(a));
    } catch (error) {
      throw this.errorMapper.mapToCodeModel(error);
    }
  }

  async getBreakdowns (
    params: IDealsDashboardFiltersDto,
    controller: Nullable<AbortController> = null,
  ): Promise<IDealsBreakdownsGetOne> {
    try {
      return await this.transport.get('/dashboard/deals/breakdowns', params, controller);
    } catch (error) {
      throw this.errorMapper.mapToCodeModel(error);
    }
  }

  async getDeals (
    params: IGetDealsDashboardListDto,
    controller: Nullable<AbortController> = null,
  ): Promise<IDealsListGetOne> {
    try {
      return await this.transport.get('/dashboard/deals', params, controller);
    } catch (error) {
      throw this.errorMapper.mapToCodeModel(error);
    }
  }

  async getDealDetail (
    id: string,
    controller: Nullable<AbortController> = null,
  ): Promise<IDealsDetailGetOne> {
    try {
      return await this.transport.get(`/dashboard/deals/${id}`, {}, controller);
    } catch (error) {
      throw this.errorMapper.mapToCodeModel(error);
    }
  }
}
